import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApplicationConstants } from '../../providers/application-constants';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-sub-menu',
  templateUrl: './sub-menu.component.html',
  styleUrls: ['./sub-menu.component.css']
})
export class SubMenuComponent implements OnInit {
  //id: string;
  items = [];

  constructor(private route: ActivatedRoute, public applicationConstants:ApplicationConstants, 
    public translate: TranslateService) {
      this.getMessages(translate);
  }

  getMessages(translate) {
    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang); 
  }

  ngOnInit() {
    // this.route.params.subscribe(params => {
      //this.id = params['id']; // (+) converts string 'id' to a number
      // console.log(params['id']);
      // this.getSubMenu(params['id']);

      // In a real app: dispatch action to load the details here.
  //  });
  }

  getSubMenu(main_id) {
    this.items = [];
    let sub_menu = [];
    let index = 0;
    let col_num = 3;
    let row_obj;

    for(let sm of this.applicationConstants.sub_menu_all) {
      if(sm.menu_id == main_id)
        sub_menu.push(sm);
    }

    let sub_menu_len = sub_menu.length;
    if(sub_menu_len == 4)
			col_num = 2;
		else if(sub_menu_len > 6 && sub_menu_len <= 8) // make number of item in row = 4
			col_num = 4;
		else if(sub_menu_len > 8  && sub_menu_len <= 10)
      col_num = 5;
    else if(sub_menu_len > 10)
			col_num = 6;

    sub_menu.forEach(element => {
      if(index % col_num == 0) {
        row_obj = {'row_index':this.items.length, 'col_list':[]};
        this.items.push(row_obj);
      } 
      row_obj.col_list.push(element);
      index++;
    });

    // console.log(this.items);
  }

}
